module.exports = __webpack_public_path__ + "static/media/phone.1fa09fb2.png";